import { createUseStyles } from 'react-jss'
import { phonesDown, tabletDown } from '../../../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  genderGraphContainer: {
    alignSelf: 'flex-start'
  },
  graphWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    top: -45
  },
  legendContainer: {
    flex: 1,
    width: 190
  },
  [`@media screen and (${tabletDown})`]: {
    genderGraphContainer: {
      alignSelf: 'stretch'
    }
  },
  [`@media screen and (${phonesDown})`]: {
    genderGraphContainer: {
      alignSelf: 'stretch'
    },
    legendContainer: {
      flex: 'unset',
      width: 'unset',
      alignSelf: 'flex-start'
    },
    graphWrapper: {
      flexDirection: 'column',
      top: 'auto'
    }
  }
})

export default useStyles
